import { toJS } from "mobx";
import { observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";
import Groupicon from "../../assets/svg/Action/videoIcon.svg";
import GroupIconblue from "../../assets/svg/Assetmanagemant/blueIcon.svg";
import deleteicon from "../../assets/svg/Assetmanagemant/deleteIcon.svg";
import option from "../../assets/svg/Assetmanagemant/optionIcon.svg";
import uploadPosterIcon from "../../assets/svg/Assetmanagemant/uploadPosterIcon.svg";
import uploadPromoIcon from "../../assets/svg/Assetmanagemant/uploadPromoIcon.svg";
import appStore from "../../Config/Store/appStore";
import InProgressVideoBlock from "./InProgressVideoBlock";

const VideoBlock = observer(
  ({
    onUploadPromos,
    data,
    onVideoClick,
    onUploadPosterClick,
    onDeleteClick,
    image_url,
    openplayercomp,
    permission,
    partitionOn = false,
  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Function to toggle the dropdown
    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };

    // Close dropdown if clicked outside
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false);
        }
      };
      if (isOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen]);

    let clickTimeout;

    const handleDoubleClick = (data) => {
      // Add your double-click functionality here
      // For example:
      openplayercomp(data);
    };

    function handleClick(data, e) {
      e.stopPropagation();
      if (e.nativeEvent.target.id === "dots") {
        return;
      }
      if (!clickTimeout) {
        // This executes on single click

        clickTimeout = setTimeout(() => {
          clickTimeout = null;
          onVideoClick(data, false, e);
        }, 200); // Adjust the delay as needed
      } else {
        // This executes on double click
        clearTimeout(clickTimeout);
        clickTimeout = null;
        handleDoubleClick(data);
      }
    }

    return (
      <>
        {data.copyStatus === 'IN_PROGRESS' ? (
          <InProgressVideoBlock
            data={data}
            permission={permission}
            deleteFunction={onDeleteClick}
          />
        ) : (
          <div
            style={{
              background:
                data.id === 11910
                  ? ""
                  : image_url !== ""
                  ? `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, rgb(50 50 57 / 55%), rgb(255 251 251), rgb(180 173 173 / 22%)) border-box`
                  : data?.isPlaceHolder
                  ? `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #280B3F, #A985ED, #280B3F) border-box`
                  : `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #0F3B47, #36D2FF, #0F3B47) border-box`,
              borderRadius: "6px",
              border: "1px solid transparent",
              padding: "5px",
              transition: " all 0.3s ",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #22BBBE, #7DAD41, #F4B719, #E55824, #B52C80) border-box`;
            }}
            onMouseLeave={(e) => {
              // Revert only the background to the original state
              e.currentTarget.style.background =
                image_url !== ""
                  ? `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, rgb(50 50 57 / 55%), rgb(255 251 251), rgb(180 173 173 / 22%)) border-box`
                  : data?.isPlaceHolder
                  ? `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #280B3F, #A985ED, #280B3F) border-box`
                  : `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #0F3B47, #36D2FF, #0F3B47) border-box`;
            }}
            className={`block ${
              data?.id === toJS(appStore.assetSignledata)?.id && partitionOn
                ? "active"
                : ""
            } ${data?.active === false ? "border border-danger" : ""}`}
            onClick={
              data?.active !== false ? (e) => handleClick(data, e) : null
            }
          >
            {image_url === "" ? (
              <div
                className="img-block"
                style={{
                  background: data?.isPlaceHolder ? "#280B3F" : "#0B2A33",
                  border: data?.isPlaceHolder ? "#D8C2FF" : "#D8C2FF",
                }}
              >
                <img
                  src={data?.isPlaceHolder ? Groupicon : GroupIconblue}
                  alt={
                    data?.isPlaceHolder
                      ? "Icon for #280B3F"
                      : "Icon for #0B2A33"
                  }
                  style={{
                    width: "35%",
                    height: "auto",
                    objectFit: "contain",
                    objectPosition: "center",
                  }}
                />
              </div>
            ) : (
              <div className="img-block p-0" style={{ overflow: "hidden" }}>
                <img
                  src={image_url}
                  style={{ width: "100%", height: "auto" }}
                  alt=""
                />
              </div>
            )}
            <div className="text-block">
              <label>
                {data?.metadata == null
                  ? data.filename
                  : data?.metadata?.title == null
                  ? data.filename
                  : data?.metadata?.title}
              </label>
            </div>
            {permission === "edit" ? (
              <div className="dropdown" ref={dropdownRef}>
                <div className="dropdown-button" onClick={toggleDropdown}>
                  <img
                    src={option}
                    alt="icon"
                    className="dropDownIcon"
                    id="dots"
                  />
                </div>
                {isOpen && (
                  <div
                    className="dropdownContent"
                    onMouseLeave={() => setIsOpen(false)}
                  >
                    <div
                      className="dropDownOptions"
                      onClick={(e) => {
                        if (e && e.stopPropagation) {
                          e.stopPropagation();
                        }

                        onUploadPosterClick(data, e);
                      }}
                    >
                      <span className="img-box">
                        <img
                          src={uploadPosterIcon}
                          alt="icon"
                          className="dropDownIcon"
                        />
                      </span>
                      Upload Poster
                    </div>

                    <div
                      className="dropDownOptions"
                      onClick={(e) => {
                        if (e && e.stopPropagation) {
                          e.stopPropagation();
                        }
                        document.getElementById("fileInputs").click();
                      }}
                    >
                      <input
                        type="file"
                        id="fileInputs"
                        style={{ display: "none" }}
                        accept=".mp4,.mov"
                        multiple
                        onChange={(e) => {
                          if (e && e.stopPropagation) {
                            e.stopPropagation();
                          }
                          onUploadPromos(e, data.id);
                        }}
                      />
                      <span className="img-box">
                        <img
                          src={uploadPromoIcon}
                          alt="icon"
                          className="dropDownIcon"
                        />
                      </span>
                      Upload Promo
                    </div>
                    {/* <div
                className="dropDownOptions"
                onClick={(e) => onArchiveClick(e)}
              >
                <span className="img-box">
                  <img src={archiveicon} alt="icon" className="dropDownIcon" />
                </span>
                Archive
              </div> */}
                    <div
                      className="dropDownOptions"
                      onClick={(e) => onDeleteClick(data.id, e)}
                    >
                      <span className="img-box">
                        <img
                          src={deleteicon}
                          alt="icon"
                          className="dropDownIcon"
                        />
                      </span>
                      Delete
                    </div>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        )}
      </>
    );
  }
);

export default VideoBlock;
